<template>
  <div
    :class="[
      'row q-gutter-x-xs text-paragraph text-grey-8',
      { 'q-px-md': spacingX, 'q-py-md': spacingY }
    ]"
  >
    <span>Based on</span>
    <span class="text-primary text-weight-bold"> {{ leaseTerm }} months </span>
    <span>at</span>
    <span class="text-primary text-weight-bold">
      {{ kmsPerYear | thousands_integer }} km
    </span>
    <span>per annum</span>
  </div>
</template>

<script>
export default {
  name: 'LeaseSummary',
  props: {
    spacingX: {
      type: Boolean,
      default: true
    },
    spacingY: {
      type: Boolean,
      default: true
    },
    leaseTerm: {
      type: Number,
      default: 0
    },
    kmsPerYear: {
      type: Number,
      default: 0
    }
  }
};
</script>
